<template>
    <div class="addtop">
        <text style="font-size: 20px;">发布商品</text>&nbsp;&nbsp;&nbsp; <text style="font-size: 14px;">当前类目
            {{ tanme[0] }}{{ tanme[1] == null ? '' : '/' + tanme[1] }}{{ tanme[2] == null ? '' : '/' + tanme[2]
            }} </text>
    </div>
    <div class="goodinfo">
        <div class="procedure">
            <div class="procedures" @click="huadong(1)">
                <div>基础信息</div>
                <div class="proceduresnub" v-if="basicInformation != 0">{{ basicInformation }}</div>
                <div v-else style="color: #C9C9C9;font-size: 12px;">已完成</div>
            </div>
            <div class="procedures" @click="huadong(2)">
                <div>销售信息</div>
                <div class="proceduresnub" v-if="salenub != 0">{{ salenub }}</div>
                <div v-else style="color: #C9C9C9;font-size: 12px;">已完成</div>
            </div>
            <div class="procedures" @click="huadong(3)">
                <div>图文描述</div>
                <div class="proceduresnub" v-if="Fileurl[0].length < 1">1</div>
                <div v-else style="color: #C9C9C9;font-size: 12px;">已完成</div>
            </div>


            <div class="procedures" @click="huadong(5)">
                <div>优惠设置</div>
                <div class="proceduresnub" v-if="paymentnub != 0"> {{ paymentnub }} </div>
                <div v-else style="color: #C9C9C9;font-size: 12px;">已完成</div>
            </div>
            <div class="procedures" @click="huadong(6)">
                <div>售后服务</div>
                <div style="color: #C9C9C9;font-size: 12px;">已完成</div>
            </div>

        </div>
        <div class="goodinfos">
            <div class="goodinfosleft">

            </div>
            <form>
                <div class="goodinfosright">
                    <div class="basisinfo">
                        <div class="basistop">基础信息</div>
                        <div class="goodname">
                            商品名称: &nbsp;&nbsp;&nbsp;<input type="text" v-model="goodmessges.basicInformation.name"
                                placeholder="请输入商品名称，最多30个字（60个字符）">
                        </div>
                        <div class="zhuyi">标题中请勿使用制表符、换行符。若填入制表符、换行符，系统将自动替换成空格</div>
                        <div class="property">

                        </div>
                    </div>


                    <div class="Sales">
                        <div class="Salest">销售信息</div>
                        <div class="xiaobiao">
                            <form action="" method="get" class="form-example">

                                <div class="form-example">
                                    <label for="name">所需积分： </label>
                                    <input type="text" name="name" id="name" required
                                        v-model="goodmessges.sale.miaosha" />
                                </div>
                                <div class="form-example">
                                    <label for="email">所需金额： </label>
                                    <input type="email" name="email" id="email" required
                                        v-model="goodmessges.sale.bianma" />
                                </div>
                                <div class="form-example">
                                    <label for="email">总数量： </label>
                                    <input type="email" name="email" id="email" required
                                        v-model="goodmessges.sale.tiaoma" />
                                </div>
                                <div class="form-example">
                                    <label for="email">可预购数量： </label>
                                    <input type="email" name="email" id="email" required
                                        v-model="goodmessges.sale.virtualQuantity" />
                                </div>

                                <div class="form-example">
                                    <label for="email">兑换说明： </label>
                                    <input type="email" name="email" id="email" required
                                        v-model="goodmessges.sale.danwei" />
                                </div>



                            </form>


                        </div>

                    </div>
                    <div class="tuwen">

                        <div class="tuwenS">图文描述</div>

                        <div class="tutext">商品图:&nbsp;&nbsp;&nbsp;建议尺寸：800*800像素，注：最大支持上传3M文件.，每个人最多500m的图片储存空间。
                        </div>
                        <div class="setupimgs">
                            <div class="setupimg">
                                <div class="seimg">
                                    <input type="file" :id="'avatar' + 0" name="avatar" accept="image/png, image/jpeg"
                                        ref="inputRef" @change="tirggerFile($event, 0, true)" />
                                </div>
                                <div class="jia">
                                    <el-icon :size="30" color="#409EFC">
                                        <Plus />
                                    </el-icon>
                                </div>
                                <div class="images" v-if="imgUrl[0] != ''" @click="openImg(true, 0)">
                                    <img style="width:100%;height: 100%;" :src="imgUrl[0]" />
                                </div>
                                <div class="tioajian">商品主图</div>
                            </div>
                            <div class="setupimg">
                                <div class="seimg">
                                    <input type="file" :id="'avatar' + 1" name="avatar" accept="image/png, image/jpeg"
                                        ref="inputRef" @change="tirggerFile($event, 1, true)" />
                                </div>
                                <div class="jia">
                                    <el-icon :size="30" color="#409EFC">
                                        <Plus />
                                    </el-icon>
                                </div>
                                <div class="images" v-if="imgUrl[1] != ''" @click="openImg(true, 1)">
                                    <img style="width:100%;" :src="imgUrl[1]" />
                                </div>
                            </div>
                            <div class="setupimg">
                                <div class="seimg">
                                    <input type="file" :id="'avatar' + 2" name="avatar" accept="image/png, image/jpeg"
                                        ref="inputRef" @change="tirggerFile($event, 2, true)" />
                                </div>
                                <div class="jia">
                                    <el-icon :size="30" color="#409EFC">
                                        <Plus />
                                    </el-icon>
                                </div>
                                <div class="images" v-if="imgUrl[2] != ''" @click="openImg(true, 2)">
                                    <img style="width:100%;" :src="imgUrl[2]" />
                                </div>
                            </div>
                            <div class="setupimg">
                                <div class="seimg">
                                    <input type="file" :id="'avatar' + 3" name="avatar" accept="image/png, image/jpeg"
                                        ref="inputRef" @change="tirggerFile($event, 3, true)" />
                                </div>
                                <div class="jia">
                                    <el-icon :size="30" color="#409EFC">
                                        <Plus />
                                    </el-icon>
                                </div>
                                <div class="images" v-if="imgUrl[3] != ''" @click="openImg(true, 3)">
                                    <img style="width:100%;" :src="imgUrl[3]" />
                                </div>
                            </div>
                            <div class="setupimg">
                                <div class="seimg">
                                    <input type="file" :id="'avatar' + 4" name="avatar" accept="image/png, image/jpeg"
                                        ref="inputRef" @change="tirggerFile($event, 4, true)" />
                                </div>
                                <div class="jia">
                                    <el-icon :size="30" color="#409EFC">
                                        <Plus />
                                    </el-icon>
                                </div>
                                <div class="images" v-if="imgUrl[4] != ''" @click="openImg(true, 4)">
                                    <img style="width:100%;" :src="imgUrl[4]" />
                                </div>
                                <div class="tioajian">商品白底图</div>

                            </div>
                            <div class="setupimg">
                                <div class="seimg">
                                    <input type="file" id="videoFile" name="videoFile" accept="video/*"
                                        ref="videoInputRef" @change="tirggerFile($event, 5, true)" />
                                </div>
                                <div class="jia">
                                    <el-icon :size="30" color="#409EFC">
                                        <Plus />
                                    </el-icon>
                                </div>
                                <div class="images" v-if="imgUrl[5] != ''" @click="openvodie">
                                    <video style="width:100%;height: 100%;" :src="imgUrl[5]" muted
                                        autoplay="false"></video>
                                </div>
                                <div class="tioajian">上传视频</div>
                            </div>
                        </div>
                        <div class="tuchaote">
                            <div>描述:&nbsp;&nbsp;&nbsp;&nbsp;</div>
                            <div style="border: 1px solid #ccc;width: 589px;height: 277px;">
                                <Toolbar style="border-bottom: 1px solid #ccc" :editor="editorRef"
                                    :defaultConfig="toolbarConfig" />
                                <Editor style="height: 245x; overflow-y: hidden;" v-model="valueHtml"
                                    :defaultConfig="editorConfig" @onCreated="handleCreated" />
                            </div>
                        </div>
                    </div>

                    <div class="zhifu">


                        <div class="zhiftop">优惠设置</div>
                        <div class="youxuan">
                            <div class="fangs">
                                <input type="checkbox" id="jieti" name="jieti" checked
                                    v-model="goodmessges.payment.jietitrue" />
                                <label for="jieti">每人限购</label>
                            </div>


                            <div class="mannumber">
                                <div style="margin-left: 23px;">限制数量： <input type="number" min="0"
                                        v-model="goodmessges.payment.jieti"></div>

                            </div>

                        </div>
                        <div class="youxuan">
                            <div class="fangs">
                                <input type="checkbox" id="manjian" name="manjian" checked
                                    v-model="goodmessges.payment.manjiantrue" />
                                <label for="manjian">每人每日限购</label>
                            </div>
                            <div class="mannumber">

                                <div style="margin-left: 23px;">限制数量： <input type="number" min="0"
                                        v-model="goodmessges.payment.manjian"></div>
                            </div>
                        </div>
                        <div class="youxuan">
                            <div class="fangs">
                                <input type="checkbox" id="isDayParting" name="isDayParting" checked
                                    v-model="goodmessges.payment.isDayParting" />
                                <label for="isDayParting">是否开启分时段</label>
                            </div>
                            <div class="mannumber">

                                <div style="margin-left: 23px;">限制数量： <input type="number" min="0"
                                        v-model="goodmessges.payment.dayParting.num"> &nbsp;
                                    <el-time-select v-model="goodmessges.payment.dayParting.startTime"
                                        style="width: 140px" :max-time="goodmessges.payment.dayParting.endTime"
                                        class="mr-4" placeholder="开始时间" start="00:00" step="00:01" end="23:59" />&nbsp;
                                    <el-time-select v-model="goodmessges.payment.dayParting.endTime"
                                        style="width: 140px" :min-time="goodmessges.payment.dayParting.startTime"
                                        placeholder="结束时间" start="00:00" step="00:01" end="23:59" />
                                </div>
                            </div>
                        </div>
                        <div class="youxuant">（打折与满减系统默认参与优惠最多的方案，并不同时参与）</div>
                    </div>
                    <div class="Aftersale">

                        <div class="fabu">
                            发布状态:&nbsp;&nbsp;
                            <input type="radio" id="huey" name="drone" value="1" checked
                                v-model="goodmessges.shouhou.zhuangtai" /><label
                                for="huey">&nbsp;上架</label>&nbsp;&nbsp;&nbsp;
                            <input type="radio" id="dewey" name="drone" value="0"
                                v-model="goodmessges.shouhou.zhuangtai" /><label for="dewey">&nbsp;仓库中</label>
                        </div>
                    </div>
                    <div style="height: 83px;"></div>
                </div>
            </form>
            <div class="over">
                <div class="overs">
                    <div class="baochun" @click="baochun(true)">
                        保存并预览
                    </div>
                    <div class="baochun" @click="productRelease">
                        发布商品
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { useRouter, useRoute } from 'vue-router';
import api from '@/api/api';
import '@wangeditor/editor/dist/css/style.css' // 引入 css

import { onBeforeUnmount, ref, shallowRef, onMounted, reactive, onUnmounted, watch } from 'vue'
import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
import { ElMessage } from 'element-plus'
import { useStore } from 'vuex';
// import {} from 'vue-router';

const route = useRoute()
const editorRef = shallowRef()
const inputRef = ref(null);
const inputRefs = ref(null)
let imgUrl = ref(['', '', '', '', '', ''])
let nums = ref(0)
let aniTimer
let sTop
let isAnimating = false
const store = useStore();
const tanme = ref([])
const tid = ref([])
const pipailist = ref([])
let productGoods = []
// const 

onUnmounted(() => {
    window.removeEventListener('scroll', handleScroll);
});
onMounted(() => {
    console.log('route.query', route.query)
    tanme.value = route.query.tanme
    tid.value = route.query.tid
    qunxain()
    storeBrand()
    productGoodsType()
    freightTemplate()
    baochun(false)
    window.addEventListener('scroll', handleScroll);
    setTimeout(() => {
        valueHtml.value = ''
    }, 1500)
})
const freighttlist = ref([])
const freightTemplate = async () => {
    let data = {
        storeId: 77,
        pageSize: 999
    }
    const res = await api.freightTemplates(data)
    console.log('freightTemplate', res)
    if (res.success) {
        freighttlist.value = res.data.tlist
    }
}
const storeBrand = async () => {
    const res = await api.storeBrand()
    console.log('storeBrand', res)
    pipailist.value = res.data.tlist
}
const productGoodsType = async () => {
    const res = await api.productGoodsType()
    productGoods = res.data.map(item => {
        return { ...item, value: item.typeName };
    });
    console.log('productGoodsType', productGoods)


}









let end = {
    hour: '',
    minute: ''
}
let start = {
    hour: '',
    minute: ''
}
const productRelease = async () => {
    console.log(goodmessges, 'goodmessges')
    let sTime = goodmessges.payment.dayParting.startTime.split(':')
    let eTime = goodmessges.payment.dayParting.endTime.split(':')
    end.hour = eTime[0]
    end.minute = eTime[1]
    start.hour = sTime[0]
    start.minute = sTime[1]

    let discountType = []
    let preferentialSet = []
    if (goodmessges.payment.manjiantrue) {
        discountType.push(6)
        // for (let a = 0; a < goodmessges.payment.manjian.length; a++) {
        //     // const element = array[a];
        //     let data = {
        //         "preferentialCondition": goodmessges.payment.manjian[a].isnumber,
        //         "preferentialDiscount": Number(goodmessges.payment.manjian[a].jian),
        //         "preferentialType": 2
        //     }
        //     preferentialSet.push(data)

        // }
    }
    if (goodmessges.payment.jietitrue) {
        discountType.push(5)
        // for (let a = 0; a < goodmessges.payment.jieti.length; a++) {
        //     // const element = array[a];
        //     let data = {
        //         "preferentialCondition": goodmessges.payment.jieti[a].isnumber,
        //         "preferentialDiscount": Number(goodmessges.payment.jieti[a].jian),
        //         "preferentialType": 1
        //     }
        //     preferentialSet.push(data)

        // }
    }
    let serviceAssuranceAfterSale = []
    if (goodmessges.shouhou.qitui) {
        serviceAssuranceAfterSale.push(1)
    }
    if (goodmessges.shouhou.bao) {
        serviceAssuranceAfterSale.push(5)
    }
    if (goodmessges.shouhou.baoyou) {
        serviceAssuranceAfterSale.push(2)
    }
    let serviceAssurancePay = []

    if (goodmessges.payment.zhuhau) {
        serviceAssurancePay.push(3)
    }
    if (goodmessges.payment.memgbi) {
        serviceAssurancePay.push(4)
    }
    if (goodmessges.payment.jifen) {
        serviceAssurancePay.push(6)
    }
    let data = {
        "productType": 2,
        "integralProductParameter": {
            "brandId": goodmessges.basicInformation.brand,
            "cateId": tid.value[0],
            "dayParting": [{
                start: start,
                end: end,
                num: goodmessges.payment.dayParting.num
            }],
            "integralBrief": valueHtml.value,
            "integralCarouselImg": Fileurl.value,
            "integralDetails": valueHtml.value,
            "integralExplain": goodmessges.sale.danwei,
            "integralFen": goodmessges.sale.miaosha,
            "integralName": goodmessges.basicInformation.name,
            "integralPrice": goodmessges.sale.bianma,
            "integralQuantity": goodmessges.sale.tiaoma,
            "integralSign": goodmessges.shouhou.zhuangtai,
            "isDayParting": goodmessges.payment.isDayParting ? '1' : '0',
            "perDayJustPersonQuotaNum": goodmessges.payment.jietitrue ? goodmessges.payment.jieti : '0',
            "perDayQuotaNum": goodmessges.payment.manjiantrue ? goodmessges.payment.manjian : '0',
            "storeId": 77,
            "virtualQuantity": goodmessges.sale.tiaoma - goodmessges.sale.virtualQuantity,

        }

    }
    console.log(data)
    if (basicInformation.value != 0) {
        ElMessage({
            message: '请完善基础信息！',
            type: 'warning',
        })
    } else if (salenub.value != 0) {
        ElMessage({
            message: '请完善销售信息！',
            type: 'warning',
        })
    } else if (Fileurl.value[0].length < 1) {
        ElMessage({
            message: '商品图至少上传一张主图！',
            type: 'warning',
        })
    } else if (paymentnub.value != 0) {
        ElMessage({
            message: '至少选择一种支付方式',
            type: 'warning',
        })
    } else {
        const res = await api.productRelease(data)
        console.log(res)
        if (res.success) {
            ElMessage({
                message: '发布成功',
                type: 'success',
            })
        } else {
            ElMessage.error('发布失败！' + res.message)
        }
    }

}
const handleScroll = (event) => {
    let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
    // console.log(scrollTop, '滚动距离')
    gunlin(scrollTop)
}
const pinpaichange = (e) => {
    console.log(e)
}
const gunlin = (y) => {
    const procedure = document.querySelector('.procedure')
    procedure.style.top = y + 'px'
}
const huadong = (num) => {
    // 页面当前滚动距离
    nums.value = num
    sTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
    let ement
    // console.log('sTop', sTop)
    if (num == 1) {
        // 处理 num 为 1 的情况
        ement = document.querySelector('.basisinfo').getBoundingClientRect()
        movewind(sTop, ement.top)
    } else if (num == 2) {
        ement = document.querySelector('.Sales').getBoundingClientRect()
        movewind(sTop, ement.top)
    } else if (num == 3) {
        ement = document.querySelector('.tuwen').getBoundingClientRect()
        movewind(sTop, ement.top)
    } else if (num == 4) {
        ement = document.querySelector('.wuliu').getBoundingClientRect()
        movewind(sTop, ement.top)
    } else if (num == 5) {
        ement = document.querySelector('.zhifu').getBoundingClientRect()
        movewind(sTop, ement.top)
    } else if (num == 6) {
        ement = document.querySelector('.Aftersale').getBoundingClientRect();
        movewind(sTop, ement.top);
    }
}

const movewind = (sTop, ementtop) => {
    let juli = parseInt(sTop + ementtop)

    let addDis = (juli - sTop) / 5

    sTop += addDis
    // console.log(sTop)
    window.scrollTo(0, sTop)
    console.log(Math.abs(juli - sTop))

    const documentHeight = document.documentElement.scrollHeight;
    const windowHeight = window.innerHeight;
    const bottomOffset = 5; // Adjust this value as needed

    if (Math.abs(juli - sTop) <= bottomOffset || sTop + windowHeight >= documentHeight) {
        nums.value = 0
        window.cancelAnimationFrame(aniTimer)
        sTop = 0
        aniTimer = null
        isAnimating = false
    } else {
        aniTimer = window.requestAnimationFrame(() => huadong(nums.value))
    }
}
const tirggerFile = (event, nub, falss) => {
    console.log(event, nub, falss);
    let file = event.target.files[0];
    let url = "";
    var reader = new FileReader();
    if (falss) {
        if (file && nub != 5) {
            console.log(file)
            reader.readAsDataURL(file);
            reader.onload = function (e) {
                url = this.result.substring(this.result.indexOf(",") + 1);
                imgUrl.value[nub] = "data:image/png;base64," + url;
                console.log(imgUrl._value)
                // that.$refs['imgimg'].setAttribute('src','data:image/png;base64,'+url);
                productFileUpload('integralCarouselImg', event.target.files[0], nub)
            };
        } else {
            console.log(file)
            reader.readAsDataURL(file);
            reader.onload = function (e) {
                url = this.result.substring(this.result.indexOf(",") + 1);
                imgUrl.value[nub] = "data:video/mp4;base64," + url;
                console.log(imgUrl._value)
                productFileUpload('integralCarouselImg', event.target.files[0], nub)

                // that.$refs['imgimg'].setAttribute('src','data:image/png;base64,'+url);
            };
        }
    } else {
        console.log(file)
        reader.readAsDataURL(file);
        reader.onload = function (e) {
            url = this.result.substring(this.result.indexOf(",") + 1);
            goodmessges.sale.CustomColor[nub].standardDetailsImgURL = "data:image/png;base64," + url;
            console.log('goodmessges.sale.CustomColor[nub]', goodmessges.sale.CustomColor[nub].standardDetailsImgURL)
            // carouselImg
            // that.$refs['imgimg'].setAttribute('src','data:image/png;base64,'+url);
            guigeUpload('integralCarouselImg', event.target.files[0], nub)
        };
    }


}
const Fileurl = ref(['', '', '', '', '', ''])
const productFileUpload = async (scopeType, files, nub) => {
    const formData = new FormData();
    formData.append('scopeType', scopeType);
    formData.append('files', files);
    const res = await api.productFileUpload(formData)
    console.log('productFileUpload', res)
    if (res.success) {
        Fileurl.value[nub] = res.data[0].data
    }
}
const guigeUpload = async (scopeType, files, nub) => {
    const formData = new FormData();
    formData.append('scopeType', scopeType);
    formData.append('files', files);
    const res = await api.productFileUpload(formData)
    console.log('productFileUpload', res)
    if (res.success) {
        goodmessges.sale.CustomColor[nub].standardDetailsImgURL = res.data[0].data
        goodmessges.sale.CustomColor[nub].carouselImg = res.data[0].data
    }
}
const openvodie = () => {
    document.getElementById('videoFile').click();

}
const openImg = (falss, index) => {
    if (falss) {
        document.getElementById('avatar' + index).click();
    } else {
        document.getElementById('avatars' + index).click();
    }
}

// 内容 HTML
const valueHtml = ref('')

// 模拟 ajax 异步获取内容

let admins = ref()
const qunxain = () => {
    let adminPermList
    let adminPermLists
    let admin
    if (localStorage.getItem('usermassage') && JSON.parse(localStorage.getItem('usermassage')).adminPermList != null) {
        adminPermList = JSON.parse(localStorage.getItem('usermassage'))
        adminPermLists = adminPermList.adminPermList
        console.log('adminPermList', adminPermLists)
        admin = adminPermLists.filter(item => item.permPathLevel == 1 && item.permName != "管理账号" && item.permName != "后台设置")
        console.log('qunxain', admin)
        admins.value = admin
    }
}



const baochun = async operationAim => {
    console.log('goodmessges', goodmessges)

    let data = {
        operationAim: operationAim,
        productType: 2
    }
    if (operationAim) {
        goodmessges.goodsimg.image = Fileurl.value
        goodmessges.goodsimg.mioashu = valueHtml.value

        const res = await api.goodsTemporarilySave(goodmessges, data)
        console.log(res)
        if (res.success) {
            ElMessage({
                message: '保存成功',
                type: 'success',
            })
        } else {
            ElMessage.error(res.message)
        }
    } else {
        const res = await api.goodsTemporarilySave('', data)
        console.log(res)
        if(res.data.obj){
            goodmessges.basicInformation = res.data.obj.basicInformation
        goodmessges.sale = res.data.obj.sale
        goodmessges.goodsimg = res.data.obj.goodsimg
        imgUrl.value = res.data.obj.goodsimg.image
        Fileurl.value = res.data.obj.goodsimg.image
        valueHtml.value = res.data.obj.goodsimg.mioashu
        goodmessges.stream = res.data.obj.stream
        goodmessges.payment = res.data.obj.payment
        goodmessges.shouhou = res.data.obj.shouhou
        console.log('goodmessges', goodmessges)
        }
       



    }

}

let goodmessges = reactive({
    basicInformation: {
        brand: '77',
        name: '',
    },
    sale: {
        miaosha: '',

        bianma: '',
        tiaoma: '',
        danwei: '',
        virtualQuantity: ''
    },
    goodsimg: {
        image: [],
        mioashu: ''
    },
    stream: {
        song: true,
        moban: '',
        daodian: false,
        shangmeng: false
    },
    payment: {
        jietitrue: false,
        jieti: '',
        manjiantrue: false,
        manjian: '',
        isDayParting: false,
        dayParting: {
            startTime: '',
            endTime: '',
            num: ''
        },
        xiangou: {
            istrue: false,
            isnumber: ''
        },
        xianshi: '',
    },
    shouhou: {
        zhuangtai: '1'
    }
})
let basicInformation = ref(1)
let salenub = ref(5)
// let stream = ref(1)
let paymentnub = ref(0)
watch(() => goodmessges, (newValue, oldValue) => {
    console.log('goodmessges 发生变化', newValue, oldValue);

    let emptyStrings = Object.values(newValue.basicInformation).filter(value => value === '');

    basicInformation.value = emptyStrings.length
    let emptyStrings2 = Object.values(newValue.sale).filter(value => value === '');
    // console.log('goodmessges 发生变化', emptyStrings2);
    salenub.value = emptyStrings2.length
    // let emptyStrings3 = Object.values(newValue.stream).filter(value => value === '');
    // stream.value = emptyStrings3.length
    // let emptyStrings4 
    // newValue.payment.zhuhau ||  memgbi || jifen
    // if (newValue.payment.zhuhau || newValue.payment.memgbi || newValue.payment.jifen) {
    //     paymentnub.value = 0
    // }

}, { deep: true });
const toolbarConfig = {}

// const 

toolbarConfig.excludeKeys = [
    'headerSelect',
    'italic',
    'fontSize',
    'fontFamily',
    'lineHeight',
    'group-more-style',
    'fullScreen',
    'undo',
    'redo',
    'divider',
    'emotion',
    'insertLink',
    'group-video',
    'insertTable',
    'codeBlock',
    'blockquote',
    'todo',
    'bgColor',
    'group-image'


]
const editorConfig = { placeholder: '请输入内容...' }

// 组件销毁时，也及时销毁编辑器
onBeforeUnmount(() => {
    const editor = editorRef.value
    if (editor == null) return
    editor.destroy()
})

const handleCreated = (editor) => {
    editorRef.value = editor // 记录 editor 实例，重要！
}


</script>

<style lang="scss" scoped>
ol,
ul {
    list-style: none;
}

input {
    outline: none;
    border: 1px solid #D9D9D9;
    height: 32px;
    padding-left: 12px;
    font-size: 14px;
    vertical-align:middle;
}
label{
    vertical-align:middle;
    font-size: 14px;
    margin-left: 5px;

}
.addtop {
    color: rgba(0, 0, 0, 0.85);
    width: 100%;
    height: 48px;
    background: #FFFFFF;
    box-shadow: 0px 3px 29px 0px rgba(196, 203, 214, 0.1);
    border-radius: 8px;
    margin-bottom: 12px;
    line-height: 48px;
    padding-left: 22px;
    box-sizing: border-box;
}

.goodinfo {
    width: 100%;
    background: #FFFFFF;
    border-radius: 8px;
    position: relative;

    .procedure {
        // display: none;
        position: absolute;
        background-color: #fff;
        top: 20px;

        .procedures {
            width: 236px;
            height: 40px;
            line-height: 40px;
            display: flex;
            align-items: center;
            padding: 0 13px 0 32px;
            box-sizing: border-box;
            justify-content: space-between;
            font-size: 14px;
            color: rgba(0, 0, 0, 0.65);

            .proceduresnub {
                width: 19px;
                height: 19px;
                border-radius: 10px;
                background: #E45B00;
                text-align: center;
                line-height: 19px;
                font-size: 13px;
                color: #FFFFFF;
            }

            // background: #E7F7FF;
        }
    }

    .goodinfos {
        display: flex;

        .goodinfosleft {
            width: 236px;
            height: 100%;
            background-color: #fff;
        }

        .goodinfosright {
            width: calc(100%);
            background-color: #fff;

            .basisinfo {
                width: 100%;

                border-bottom: 1px solid #707070;
                box-sizing: border-box;
                color: #666666;


                .basistop {
                    font-size: 14px;
                    font-family: PingFangSC, PingFang SC;
                    font-weight: 600;
                    color: #2A2A2A;
                    margin: 22px 0 0 37px;
                }

                .goodname {
                    color: #666666;
                    margin: 16px 0 0 54px;


                    input {
                        outline: none;
                        border: 1px solid #D9D9D9;
                        width: 762px;
                        height: 32px;
                        padding-left: 12px;
                    }

                }

                .zhuyi {
                    font-size: 12px;
                    font-weight: 400;
                    color: #C1C1C1;
                    margin: 7px 0 0 140px;
                }

                .property {
                    margin: 32px 0 38px 54px;




                }
            }



            .Sales {
                transition: transform 0.3s ease-in-out;
                color: #666666;

                .Salest {
                    margin: 28px 0 0 37px;
                    font-size: 14px;
                    font-weight: 600;

                    line-height: 20px
                }

                .stext {
                    margin: 19px 0 0 40px;
                    font-size: 14px;
                }

                .kuanshi {
                    width: 500px;
                    margin: 0 24px 0 128px;

                    .colorchoose {
                        width: 100%;
                        display: flex;
                        align-items: center;

                    }

                }

                .stable {
                    margin: 7px 0 0 120px;

                    table {
                        border-collapse: collapse;

                        thead {
                            th {
                                padding: 7px;
                                border: 1px solid rgba(112, 112, 112, 0.16);

                                .tatext {
                                    width: 90px;
                                    height: 32px;
                                    border: 1px solid #D9D9D9;
                                    font-size: 11px;
                                    line-height: 32px;

                                }
                            }


                        }

                        tbody {
                            td {
                                width: 100px;
                                padding: 7px;
                                border-right: 1px solid rgba(112, 112, 112, 0.16);
                                box-sizing: border-box;

                                .setupimg {
                                    width: 80px;
                                    height: 30px;
                                    // background: #F2F3F5;
                                    position: relative;

                                    .images {
                                        position: absolute;
                                        top: 0;
                                        left: 0;
                                        width: 100%;
                                        height: 100%;
                                        overflow: hidden;
                                        // video{
                                        //     width: 100%;
                                        //     height: 100%;
                                        // }
                                    }

                                    .jia {
                                        position: absolute;
                                        cursor: pointer;
                                        width: 100%;
                                        top: 50%;
                                        left: 50%;
                                        transform: translate(-50%, -50%);
                                    }

                                    .seimg {

                                        width: 80px;
                                        height: 80px;

                                        input {
                                            padding: 0;
                                            width: 100%;
                                            height: 100%;
                                            opacity: 0;
                                            vertical-align: baseline;

                                        }
                                    }

                                    .tioajian {
                                        width: 80px;
                                        height: 23px;
                                        background: #8F8F8F;
                                        font-size: 11px;
                                        line-height: 23px;
                                        text-align: center;
                                        font-weight: 400;
                                        color: #FFFFFF;
                                    }
                                }

                                input {
                                    width: 70%;
                                }
                            }

                            :last-child {
                                border: none;

                            }
                        }
                    }
                }

                .xiaobiao {
                    margin: 52px 0 0 0;
                    font-size: 14px;
                    border-bottom: 1px solid #707070;
                    padding-bottom: 25px;

                    input {
                        width: 456px;
                        height: 32px;

                    }

                    form {
                        margin-left: 123px;

                        .form-example {

                            margin-top: 17px;

                            label {
                                display: inline-block;
                                width: 90px;
                                text-align: right;
                            }

                        }
                    }


                }

            }

            .tuwen {
                font-size: 13px;
                font-weight: 400;
                color: #666666;
                border-bottom: 1px solid #707070;
                padding-bottom: 28px;

                .setupimgs {
                    display: flex;
                    justify-content: space-between;
                    margin: 4px 0 0 100px;
                    width: 600px;

                    .setupimg {
                        width: 80px;
                        height: 80px;
                        background: #F2F3F5;
                        position: relative;

                        .images {
                            position: absolute;
                            top: 0;
                            left: 0;
                            width: 100%;
                            height: 100%;
                            overflow: hidden;
                            // video{
                            //     width: 100%;
                            //     height: 100%;
                            // }
                        }

                        .jia {
                            position: absolute;
                            top: 50%;
                            left: 50%;
                            transform: translate(-50%, -50%);
                        }

                        .seimg {

                            width: 80px;
                            height: 80px;

                            input {
                                padding: 0;
                                width: 100%;
                                height: 100%;
                                opacity: 0;
                            }
                        }

                        .tioajian {
                            width: 80px;
                            height: 23px;
                            background: #8F8F8F;
                            font-size: 11px;
                            line-height: 23px;
                            text-align: center;
                            font-weight: 400;
                            color: #FFFFFF;
                        }
                    }
                }



                .tuwenS {
                    margin: 28px 0 0 37px;
                    font-size: 14px;
                    font-weight: 600;

                    line-height: 20px
                }

                .tutext {
                    margin: 25px 0 0 46px;
                }

                .tuchaote {
                    margin: 41px 0 0 54px;
                    display: flex;


                }

            }



            .zhifu {
                padding-bottom: 26px;
                border-bottom: 1px solid #707070;


                .zhiftop {
                    font-size: 14px;
                    font-weight: 600;
                    color: #2A2A2A;
                    margin: 22px 0 0 34px;
                }



                .youxuant {
                    margin: 11px 0 0 90px;
                    font-size: 12px;
                    font-weight: 400;
                    color: #666666;
                }

                .youxuan {
                    color: #666666;
                    margin: 23px 0 0 100px;

                    .fangs {
                        margin-top: 17px;

                        input {
                            width: 19px;
                            height: 19px;

                        }
                    }

                    .mannumber {

                        width: 831px;
                        height: 79px;
                        background: #F7F7F7;
                        border: 1px solid rgba(112, 112, 112, 0.10);
                        margin-top: 14px;
                        display: flex;
                        align-items: center;
                        font-size: 14px;
                        color: #666666;

                        input {
                            width: 173px;
                            background-color: #fff;
                        }


                        .mancuo {
                            div {
                                margin-left: 15px;

                            }

                            display: flex;
                            font-size: 12px;
                            font-weight: 400;
                            color: #1890FF;

                        }
                    }



                }
            }

            .Aftersale {


                .fabu {
                    font-size: 14px;
                    font-weight: 400;
                    color: #666666;
                    display: flex;
                    align-items: center;
                    margin: 23px 0 0 50px;

                    input {
                        width: 18px;
                        height: 18px;
                    }

                    label {
                        font-size: 14px;
                        font-weight: 400;
                        color: #666666;

                    }
                }

            }






        }

    }


}

.over {
    position: absolute;
    bottom: 0px;
    width: 100%;
    height: 61px;
    background: #FFFFFF;
    box-shadow: 0px -3px 6px 0px rgba(0, 0, 0, 0.16);
    display: flex;
    justify-content: center;
    align-items: center;


    .overs {
        display: flex;
        width: 356px;
        justify-content: space-between;

        .baochun {
            width: 148px;
            height: 48px;
            background: #444444;
            border-radius: 8px;
            color: #FFFFFF;
            line-height: 48px;
            text-align: center;
        }
    }



}
</style>